import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useChangePassword = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.IChangePasswordRequestData) => {
        return await send<Types.IChangePasswordRequestData>({
            ID: 31028,
            responses: [31029, 31030],
            description: 'Change password',
            ...request
        });
    }, [send]);
};
